// Calculates the correct number of bulls that are shown using the filters applied
export function CalculateSelectedBullCount(data) {
    let selectedBullCount = data.length;
    if (data.filter(f => f.RegId == null).length > 0)
    {
        selectedBullCount = data.length - 1;
    }
    return selectedBullCount;
}